// userDataSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../../api";

export const fetchAttendance = createAsyncThunk("attendance/fetchAttendance", async () => {
  const response = await api.post("/attendance");
  return response.data.data;
});

export const addAttendance = createAsyncThunk(
  "attendance/addAttendance",
  async (attendanceData, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.post("/add-attendance", attendanceData);
      dispatch(fetchAttendance());
      dispatch(closeAttendanceModal());
      return response.data.message;  // Assuming success message is in the response data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to save attendance record");
    }
  }
);


export const deleteAttendance = createAsyncThunk(
  "attendance/deleteAttendance",
  async (attendanceId, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.post(`/delete-attendance/${attendanceId}`);
      dispatch(fetchAttendance());
      return response.data.message;  // Assuming success message is in the response data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to delete attendance record");
    }
  }
);

// Slice
const attendanceSlice = createSlice({
  name: "attendanceData",
  initialState: {
    data: [],
    loading: false,
    isModalOpen: false,
    selectedUserId: null,
    addLoading: false,
    deleteLoading: false,
    error: null,
    successMessage: null,  // To store success messages from backend
  },
  reducers: {
    openAttendanceModal: (state, action) => {
      state.isModalOpen = true;
      state.selectedUserId = action.payload || null;
    },
    closeAttendanceModal: (state) => {
      state.isModalOpen = false;
      state.selectedUserId = null;
      state.error = null;
      state.successMessage = null;  // Reset on modal close
    },
    clearError: (state) => {
      state.error = null;
      state.successMessage = null;  // Optionally clear success message
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAttendance.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAttendance.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(fetchAttendance.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(addAttendance.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(addAttendance.fulfilled, (state, action) => {
        state.addLoading = false;
        state.successMessage = action.payload;
      })
      .addCase(addAttendance.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
      })
      .addCase(deleteAttendance.pending, (state) => {
        state.deleteLoading = true;
      })
      .addCase(deleteAttendance.fulfilled, (state, action) => {
        state.deleteLoading = false;
        state.successMessage = action.payload;
      })
      .addCase(deleteAttendance.rejected, (state, action) => {
        state.deleteLoading = false;
        state.error = action.payload;
      });
  },
});

export const { openAttendanceModal, closeAttendanceModal, clearError } = attendanceSlice.actions;
export default attendanceSlice.reducer;
export { attendanceSlice };
